<script lang="ts">
  import { _ } from 'svelte-i18n';
  import { groupRoles } from '$lib/stores/selection';

  /**
   * The company's place in a group, as websites state it: the parent, which
   * lists subsidiaries or is named as one's parent, and the subsidiary, which
   * names a parent or is listed as one's subsidiary. Both ticked mean either.
   *
   * Switched on by the customer or by a selection arriving, and off only by
   * the customer, which clears it — the contract every filter in this panel
   * keeps.
   */
  const roles = ['parent', 'subsidiary'];

  let enabled = false;
  $: if ($groupRoles.length > 0) enabled = true;

  function toggleEnabled() {
    enabled = !enabled;
    if (!enabled) groupRoles.set([]);
  }

  function toggle(role: string) {
    groupRoles.set(
      $groupRoles.includes(role) ? $groupRoles.filter((r) => r !== role) : [...$groupRoles, role]
    );
  }

  const checkbox =
    'h-3 w-3 rounded border-gray-300 text-accent-600 focus:ring-1 focus:ring-accent-200';
</script>

<div class={enabled ? 'm-2 rounded-control bg-surface-well p-3' : 'p-3'}>
  <label class="group flex cursor-pointer items-center" title={$_('filters.group.explain')}>
    <input type="checkbox" checked={enabled} on:click={toggleEnabled} class="mr-2 {checkbox}" />
    <svg class="filter-mark mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M12 3v6m0 0H6a2 2 0 00-2 2v2m8-4h6a2 2 0 012 2v2M4 13h4v4H4zm12 0h4v4h-4zm-6 0h4v4h-4z"
      />
    </svg>
    <span class="text-xs font-semibold text-gray-900 transition-colors group-hover:text-gray-700">
      {$_('filters.group.title')}
    </span>
  </label>

  {#if enabled}
    <div class="mt-3 space-y-2">
      <p class="text-xs text-gray-400">{$_('filters.group.anyOf')}</p>
      {#each roles as role (role)}
        <label class="flex cursor-pointer items-start gap-2">
          <input
            type="checkbox"
            checked={$groupRoles.includes(role)}
            on:change={() => toggle(role)}
            class="mt-0.5 {checkbox}"
          />
          <span class="min-w-0">
            <span class="block text-sm text-gray-900">{$_(`filters.group.${role}`)}</span>
            <span class="block text-2xs text-gray-500">{$_(`filters.group.${role}Hint`)}</span>
          </span>
        </label>
      {/each}
    </div>
  {/if}
</div>
